import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, map } from 'rxjs';
import { DashboardRequest, DashboardTableRequest } from 'src/app/modules/Disbursment_modules/dis-dashboard.component.model';
import { CommonHttpModule } from '../../providers/commonHttpModule';
import { SavingsInsightsResponse } from 'src/app/modules/Disbursment_modules/dis-dashboard/dis-dashboard.component';


@Injectable({
  providedIn: 'root'
})
export class DisbursmentService {
    constructor(private http: CommonHttpModule) { }


    getDashboardData(request: DashboardRequest): Observable<any> {
        return this.http.post("dashboard", request).pipe(
            map((response) => {
                return response;
            })
        )
    }

    getDashboardTableData(request: DashboardTableRequest): Observable<any> {
        return this.http.post("dashboard-table", request).pipe(
            map((response) => {
                return response;
            })
        )
    }

     getVesselListData(payload: any): Observable<any> {
    return this.http.post("dashboard-filter-data", payload).pipe(
        map((response) => {
            return response;
        })
    );
}

     private loadingSubject = new BehaviorSubject<boolean>(false);
  private dialogLoadingSubject = new BehaviorSubject<boolean>(false);

  loading$ = this.loadingSubject.asObservable();
  dialogLoading$ = this.dialogLoadingSubject.asObservable();

  show(): void {
    this.loadingSubject.next(true);
  }

  hide(): void {
    this.loadingSubject.next(false);
  }

  showDialogLoader(): void {
    this.dialogLoadingSubject.next(true);
  }

  hideDialogLoader(): void {
    this.dialogLoadingSubject.next(false);
  }

updateDashboardRow(request: any): Observable<any> {
  return this.http.post(
    'dashboard-table/update-row',
    request
  ).pipe(
    map((response) => {
      return response;
    })
  );
}
verifyDashboard(request: any): Observable<any> {
  return this.http.get(
    'verify',
    {
      params: request
    }
  ).pipe(
    map((response) => response)
  );
}
getSavingsInsights(request: any): Observable<any> {
  return this.http.post(
    'dashboard/savings-insights',
    request
  ).pipe(
    map((response) => {
      return response;
    })
  );
}
getNegotiations(request: any): Observable<any> {
  return this.http.post(
    'dashboard/negotiations',
    request
  ).pipe(
    map((response) => {
      return response;
    })
  );
}

getHoverStats(request: any): Observable<any> {
  return this.http.post(
    'dashboard/hover-stats',
    request
  ).pipe(
    map((response) => {
      return response;
    })
  );
}
getSavingsGraphData(request: any): Observable<any> {
  return this.http.post(
    'dashboard/savings-graph',
    request
  ).pipe(
    map((response) => {
      return response;
    })
  );
}
getSavingsDetailsTable(request: any): Observable<any> {
  return this.http.post(
    'dashboard/savings-details-table',
    request
  ).pipe(
    map((response) => {
      return response;
    })
  );
}
generateChatbotResponse(question: string, file?: File, history: any[] = []): Observable<any> {
    const formData = new FormData();
    formData.append('question', question || '');
    formData.append('history', JSON.stringify(history || []));

    if (file) {
      formData.append('file', file, file.name);
    }

    return this.http.post('chatbot/query', formData).pipe(
      map((response) => response)
    );
  }
}
